import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import List from "@material-ui/core/List"
import ListItem from "@material-ui/core/ListItem"
import ListItemIcon from "@material-ui/core/ListItemIcon"
import ListItemText from "@material-ui/core/ListItemText"
import Link from "@material-ui/core/Link"
import Button from "@material-ui/core/Button"
import { Article, Section } from "../../components/section2"
import ContatoMap from "./contatoMap"
import useTheme from "@material-ui/styles/useTheme"

import InstagramIcon from "@material-ui/icons/Instagram"
import WhatsAppIcon from "@material-ui/icons/WhatsApp"
import MailOutlineIcon from "@material-ui/icons/MailOutline"
import PhoneInTalkIcon from "@material-ui/icons/PhoneInTalk"

import useStyles from "./styles"

const ContatoSectionContent = () => {
  const {
    file: { publicURL: place },
  } = useStaticQuery(graphql`
    query {
      file(relativePath: { eq: "localizacao.svg" }) {
        publicURL
      }
    }
  `)

  const theme = useTheme()
  const classes = useStyles(theme)

  return (
    <>
      <Article id="contato" background="true">
        <Section style={{ textAlign: "center" }} xs={12} sm={12} md={9} lg={8}>
          <Typography component="h1" variant="h4">
            Endereço e Contato
          </Typography>

          <Typography paragraph>
            Agende um horário, tire dúvidas, faça uma visita. O atendimento
            presencial e pelos canais de comunicação se dá de segunda a
            sexta-feira das 08:00h as 17:00h.
          </Typography>

          <Grid container justifyContent="space-around">
            <Grid
              container
              item
              xs={12}
              sm={6}
              justifyContent="flex-end"
              alignItems="center"
              className={classes.channelListBlock}
            >
              <List dense={true}>
                <ListItem>
                  <ListItemText
                    className={classes.alignTextRight}
                    primary={
                      <Link
                        className={classes.contactLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        href="https://www.google.com/maps/dir//Cart%C3%B3rio+de+Registro+de+Im%C3%B3veis+da+1%C2%AA+Circunscri%C3%A7%C3%A3o+de+An%C3%A1polis%2FGO,+Avenida+Universit%C3%A1ria+2221+Anashopping,+LUC+100,+An%C3%A1polis+-+GO,+75083-350/@-16.3024582,-48.983803,13z/data=!4m9!4m8!1m0!1m5!1m1!1s0x935ea478c24e862f:0xb9892c58bf9d6cd9!2m2!1d-48.9487834!2d-16.3024611!3e0?hl=pt-BR&entry=ttu&g_ep=EgoyMDI2MDIxOC4wIKXMDSoASAFQAw%3D%3D"
                      >
                        Av. Universitária, nº 2221
                        <br /> Anashopping, LUC 100
                        <br /> Anápolis/GO
                        <br /> CEP: 75.083-350
                      </Link>
                    }
                  />
                  <ListItemIcon className={classes.listItemIcon}>
                    <Link
                      target="_blank"
                      rel="noopener noreferrer"
                      href="https://www.google.com/maps/dir//Cart%C3%B3rio+de+Registro+de+Im%C3%B3veis+da+1%C2%AA+Circunscri%C3%A7%C3%A3o+de+An%C3%A1polis%2FGO,+Avenida+Universit%C3%A1ria+2221+Anashopping,+LUC+100,+An%C3%A1polis+-+GO,+75083-350/@-16.3024582,-48.983803,13z/data=!4m9!4m8!1m0!1m5!1m1!1s0x935ea478c24e862f:0xb9892c58bf9d6cd9!2m2!1d-48.9487834!2d-16.3024611!3e0?hl=pt-BR&entry=ttu&g_ep=EgoyMDI2MDIxOC4wIKXMDSoASAFQAw%3D%3D"
                    >
                      <img
                        src={place}
                        alt="Endereço: Av. Universitária, nº 2221 - Anashopping - Anápolis/GO"
                        className={classes.locationImg}
                      />
                    </Link>
                  </ListItemIcon>
                </ListItem>
                <ListItem>
                  <Button
                    size="small"
                    variant="outlined"
                    color="inherit"
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://www.google.com/maps/dir//Cart%C3%B3rio+de+Registro+de+Im%C3%B3veis+da+1%C2%AA+Circunscri%C3%A7%C3%A3o+de+An%C3%A1polis%2FGO,+Avenida+Universit%C3%A1ria+2221+Anashopping,+LUC+100,+An%C3%A1polis+-+GO,+75083-350/@-16.3024582,-48.983803,13z/data=!4m9!4m8!1m0!1m5!1m1!1s0x935ea478c24e862f:0xb9892c58bf9d6cd9!2m2!1d-48.9487834!2d-16.3024611!3e0?hl=pt-BR&entry=ttu&g_ep=EgoyMDI2MDIxOC4wIKXMDSoASAFQAw%3D%3D"
                    classes={{ root: classes.routeButton }}
                  >
                    Clique para traçar rota
                  </Button>
                </ListItem>
              </List>
            </Grid>

            <Grid
              container
              item
              xs={12}
              sm={6}
              alignItems="center"
              className={classes.channelListBlock}
            >
              <List dense={true}>
                <ListItem className={classes.listItem}>
                  <ListItemIcon className={classes.listItemIcon}>
                    <MailOutlineIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography variant="body2">
                        <Link
                          className={classes.contactLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          href="mailto:primeirocartorioregistro@gmail.com"
                        >
                          email: <wbr />
                          primeirocartorioregistro
                          <wbr />
                          @gmail.com
                        </Link>
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem className={classes.listItem}>
                  <ListItemIcon className={classes.listItemIcon}>
                    <PhoneInTalkIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography variant="body2">
                        <Link
                          className={classes.contactLink}
                          href="tel:+556239374650"
                        >
                          telefone: <wbr />
                          (62) 3937-4650
                        </Link>
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem className={classes.listItem}>
                  <ListItemIcon className={classes.listItemIcon}>
                    <WhatsAppIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography variant="body2">
                        <Link
                          className={classes.contactLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://wa.me/556239374650"
                        >
                          whatsapp: <wbr />
                          (62) 3937-4650
                        </Link>
                      </Typography>
                    }
                  />
                </ListItem>
                <ListItem className={classes.listItem}>
                  <ListItemIcon className={classes.listItemIcon}>
                    <InstagramIcon />
                  </ListItemIcon>
                  <ListItemText
                    primary={
                      <Typography variant="body2">
                        <Link
                          className={classes.contactLink}
                          target="_blank"
                          rel="noopener noreferrer"
                          href="https://www.instagram.com/ri1anapolis/"
                        >
                          instagram: <wbr />
                          @ri1anapolis
                        </Link>
                      </Typography>
                    }
                  />
                </ListItem>
              </List>
            </Grid>
          </Grid>
        </Section>
      </Article>
      <ContatoMap />
    </>
  )
}

export default ContatoSectionContent
